import { isValidElement, createElement } from 'react';

/**
 * Checks whether the given element is an Emotion wrapper element.
 *
 * @param element - The element to check.
 */ function isEmotionElement(element) {
    return isValidElement(element) && 'css' in element.props;
}
/**
 * Unwraps a single Emotion element.
 *
 * @param child - The child to process.
 */ function unwrapEmotionElement(child) {
    if (isEmotionElement(child)) {
        const { __EMOTION_TYPE_PLEASE_DO_NOT_USE__: type, ...props } = child.props;
        return createElement(type, {
            ...props,
            key: child.key
        });
    }
    return child;
}
/**
 * A hook that unwraps Emotion elements from the children of a component.
 *
 * @param children - The children to process.
 */ function unwrapEmotionElements(children) {
    if (Array.isArray(children)) {
        return children.filter((child)=>isValidElement(child)).map((child)=>unwrapEmotionElement(child));
    } else if (typeof children === 'function') {
        return (...args)=>unwrapEmotionElement(children(...args));
    } else if (!isValidElement(children)) {
        return children;
    }
    return unwrapEmotionElement(children);
}

export { isEmotionElement, unwrapEmotionElement, unwrapEmotionElements };
//# sourceMappingURL=emotion-element.js.map
